// Copyright (c) 2016 Deere & Company

import './claim-action-popover.scss';
import React, {PropTypes} from 'react';
import ActionButton from './claim-action-button';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import {FormattedMessage} from 'react-intl';
import Popover from '../../../../shared/components/popover/popover';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import {hasAccess} from '../../../../shared/services/security';
import {sortActions} from '../../../shared/services/claim-shared-helper';

const ClaimActionPopover = (props, context) => {

    let securedActions;

    securedActions = [];

    if (!hasAccess(context.security, 'CLAIM', 'CLM_CLAIM_CREATE')) {

        securedActions = securedActions.concat(['ADD_REP', 'COPY_CLAIM', 'CRT']);

    }

    if (!hasAccess(context.security, 'CLAIM', 'CLM_CLAIM_EDIT')) {

        securedActions = securedActions.concat(['DEL', 'RECONCILE', 'REVISE', 'SUB']);

    }

    const allowedActions = props.actions.filter(action => !securedActions.includes(action.actionName));

    const popoverTarget = (
        <button
            className='claims-action-popover-button'
            disabled={props.isActionButtonDisabled}
        >
            <FormattedMessage id='ACTIONS'/>
        </button>
    );

    const popoverContent = (
        <ul className='claim-actions-popover-list'>
            {sortActions(allowedActions).map(action =>
                <li
                    key={action.id}
                >
                    <ActionButton
                        action={action}
                        claimNumber={props.claimNumber}
                        claimStatus={props.claimStatus}
                        creditMemoNumber={props.creditMemoNumber}
                        onActionClick={props.onActionClick}
                    />
                </li>
            )}
        </ul>
    );

    return (
        <Popover
            content={popoverContent}
            target={popoverTarget}
        />
    );

};

ClaimActionPopover.displayName = 'ClaimActionPopover';
ClaimActionPopover.propTypes = {
    actions: PropTypes.arrayOf(PropTypes.instanceOf(ClaimAction)).isRequired,
    claimNumber: PropTypes.string.isRequired,
    claimStatus: PropTypes.string.isRequired,
    creditMemoNumber: PropTypes.string.isRequired,
    isActionButtonDisabled: PropTypes.bool,
    onActionClick: PropTypes.func.isRequired
};
ClaimActionPopover.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired
};

export default ClaimActionPopover;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-action-button/claim-action-popover.js